import { useDispatch, useSelector } from "react-redux";
import { clearAlert, setAlert } from "../../redux/alertNotificationSlice";

export const useAlertNotification = () => {
  const alert = useSelector(state => state.alertNotification.alert);
  const dispatch = useDispatch();

  return {
    getAlert: () => alert,
    setAlert: (alertObj) => dispatch(setAlert(alertObj)),
    clearAlert: () => dispatch(clearAlert()),
  };
};
